import { graphql } from 'generated/gql/account-manager';
import { useAmQuery } from 'graphql/useAmQuery';

const siteQueryDocument = graphql(`
  query site($platformSiteId: Int) {
    site(platformSiteId: $platformSiteId) {
      platformSiteId
      subdomain
      mappedDomain
      category
      registeredAt
      blockTheme
      accountId
      marketingStrategyId
      owner {
        wordpressUserId
        wordpressUsername
      }
      googleAuthConfig {
        id
      }
      semrushProviderProjectId
    }
  }
`);

// TODO: ALUM - after all routes have an accountId, consider removing this and
// replacing it with a `useSite` hook that gets the site from the account
// data.
export function useSiteQuery(siteId: number | undefined) {
  return useAmQuery(
    siteQueryDocument,
    { platformSiteId: siteId },
    { enabled: !!siteId }
  );
}
